export default {"src":"/_next/static/image/src/components/Tooltip/tooltip-icon.71e40e6a3d989bd90e5ebc2d573ee0c4.svg","height":18,"width":18};